// 订单接口
import axios from '../axios'

export const getThirdPartyOrderList = (data) => {
  return axios({
    url: '/con/third/party/order/list',
    method: 'GET',
    data
  })
}

export const getTeacherList = () => {
  return axios({
    url: '/con/third/party/order/getTeacherList',
    method: 'GET'
  })
}

export const checkOrderDetailForId = (data) => {
  return axios({
    url: '/con/third/party/order/detail',
    method: 'POST',
    data
  })
}


// WEBPACK FOOTER //
// ./src/http/moudules/orderManagement.js